import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Navbar from '../../components/Navbar'
import registerImage from '../../images/loginimage.jpg'
import styles from '../../styles/register.module.css'

function Register() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const validate = () => {
    if (!name.trim()) {
      toast.error('Please enter your name', {
        position: 'bottom-right',
        theme: 'colored'
      })
      return false
    }
    if (!email.trim()) {
      toast.error('Please enter your email address', {
        position: 'bottom-right',
        theme: 'colored'
      })
      return false
    }
    if (password.length < 6) {
      toast.error('Password must be at least 6 characters', {
        position: 'bottom-right',
        theme: 'colored'
      })
      return false
    }
    return true
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!validate()) return

    try {
      setLoading(true)

      const response = await axios.post(
        'https://pro-shop-backend.vercel.app/api/users',
        { name: name.trim(), email: email.trim(), password },
        { withCredentials: true }
      )

      toast.success(response.data.message || 'Registration successful! Please check your email for verification code.', {
        position: 'bottom-right',
        theme: 'colored'
      })
      setTimeout(() => navigate('/login'), 1500)
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Registration failed. Please try again.'
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Navbar />

      <main className={styles.page}>
        <section className={styles.card}>
          <aside className={styles.banner}>
            <img src={registerImage} alt="Cyclist on a mountain trail" className={styles.bannerImage} />
            <div className={styles.bannerOverlay} />

            <div className={styles.bannerContent}>
              <span className={styles.badge}>Welcome to ProShop</span>

              <h1>
                Gear up.
                <br />
                Ride further.
              </h1>

              <p>Create your account to track orders, save your builds, and check out faster.</p>

              <div className={styles.benefits}>
                <span>✓ Secure checkout</span>
                <span>✓ Fast delivery</span>
                <span>✓ Exclusive offers</span>
              </div>
            </div>
          </aside>

          <section className={styles.formSection}>
            <div className={styles.formWrapper}>
              <div className={styles.heading}>
                <span className={styles.eyebrow}>Create account</span>
                <h2>Start riding today</h2>
                <p>Enter your details below to create your account.</p>
              </div>

              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.field}>
                  <label htmlFor="name">Full name</label>
                  <input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    placeholder="John Doe"
                    autoComplete="name"
                    disabled={loading}
                  />
                </div>

                <div className={styles.field}>
                  <label htmlFor="email">Email address</label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="johndoe@example.com"
                    autoComplete="email"
                    disabled={loading}
                  />
                </div>

                <div className={styles.field}>
                  <label htmlFor="password">Password</label>

                  <div className={styles.passwordWrapper}>
                    <input
                      id="password"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      placeholder="Minimum 6 characters"
                      autoComplete="new-password"
                      disabled={loading}
                    />

                    <button
                      type="button"
                      className={styles.passwordToggle}
                      onClick={() => setShowPassword(!showPassword)}
                      disabled={loading}
                    >
                      {showPassword ? 'Hide' : 'Show'}
                    </button>
                  </div>
                </div>

                <button type="submit" className={styles.submit} disabled={loading}>
                  {loading ? (
                    <>
                      <span className={styles.spinner} />
                      Creating account...
                    </>
                  ) : (
                    'Create account'
                  )}
                </button>
              </form>

              <p className={styles.loginText}>
                Already have an account? <Link to="/login">Sign in</Link>
              </p>
            </div>
          </section>
        </section>
      </main>

      <ToastContainer 
        position="bottom-right" 
        theme="colored" 
        autoClose={3500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}

export default Register